import { z } from 'zod/v3';
import { SourceTypeSchema, SourceStatusSchema } from '../generated/enums';

// Base source schema
export const SourceDTOSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: SourceTypeSchema,
  status: SourceStatusSchema,
  content: z.string().nullable(),
  workspaceId: z.string(),
  externalId: z.string().nullable(),
  externalUrl: z.string().nullable(),
  metadata: z.record(z.any()).nullable(),
  icon: z.string().nullable(),
  pendingIngestionJobId: z.string().nullable(),
}).strict();

// Get sources query schema
export const GetSourcesQueryDTOSchema = z.object({
  offset: z.number().min(0).nullish(),
  limit: z.number().min(1).max(100).nullish(),
  cursor: z.string().nullish(),
  type: SourceTypeSchema.optional(),
  status: SourceStatusSchema.optional(),
  workspaceId: z.string(),
}).strict();

// Search sources query schema
export const SearchSourcesQueryDTOSchema = z.object({
  workspaceId: z.string(),
  query: z.string().min(1),
  limit: z.number().min(1).max(50).nullish(),
  type: SourceTypeSchema.optional(),
}).strict();

// Get source by ID schema
export const GetSourceByIdDTOSchema = z.object({
  id: z.string(),
}).strict();

// Delete sources schema
export const DeleteSourcesDTOSchema = z.object({
  ids: z.array(z.string()),
}).strict();

// Upload file content schema
export const UploadFileContentDTOSchema = z.object({
  filename: z.string(),
  contentType: z.string(),
  content: z.string(), // Base64 encoded file content
  size: z.number(),
}).strict();

// Register uploaded file schema
export const RegisterUploadedFileDTOSchema = z.object({
  url: z.string().url(),
  filename: z.string(),
  contentType: z.string(),
  size: z.number(),
  workspaceId: z.string(),
}).strict();

// Get upload URL schema
export const GetUploadUrlDTOSchema = z.object({
  filename: z.string(),
  contentType: z.string(),
}).strict();

// Upload file schema
export const UploadFileDTOSchema = z.object({
  filename: z.string(),
  fileKey: z.string(),
  contentType: z.string(),
  size: z.number(),
}).strict();

// Export types
export type SourceDTO = z.infer<typeof SourceDTOSchema>;
export type GetSourcesQueryDTO = z.infer<typeof GetSourcesQueryDTOSchema>;
export type SearchSourcesQueryDTO = z.infer<typeof SearchSourcesQueryDTOSchema>;
export type GetSourceByIdDTO = z.infer<typeof GetSourceByIdDTOSchema>;
export type DeleteSourcesDTO = z.infer<typeof DeleteSourcesDTOSchema>;
export type UploadFileContentDTO = z.infer<typeof UploadFileContentDTOSchema>;
export type RegisterUploadedFileDTO = z.infer<typeof RegisterUploadedFileDTOSchema>;
export type GetUploadUrlDTO = z.infer<typeof GetUploadUrlDTOSchema>;
export type UploadFileDTO = z.infer<typeof UploadFileDTOSchema>; 
